export const API_FAILED_TITLE = 'Attention';
export const API_FAILED_CONTENT =
  "We're sorry, but an unexcepted error has occured. Please try again.";
export const API_FAILED_CONTENTSECOND = 'Please try again';
export const OK = 'OK';
export const CANCEL_BTN = 'Cancel';
